
import {
  PersonAdd,
  NoteAdd,
} from "@mui/icons-material";

import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

import { EventPerformanceReport } from "./components/EventPerformanceReport";
import { CancelationReasonReport } from "./components/CancelationReasonReport";
import { VenueReport } from "./components/VenueReport";
import { Counts } from "../Dashboard/Counts";
import { ALLOWED_MODULES } from "../../../constants/enums";
import { AccessGuard } from "../../../router/AccessGuard";

export function MainDashboard() {
  return (
    <Box sx={{ px: 2, maxWidth: "100%", overflowX: "hidden" }}>
      <Counts />
      <Grid container spacing={1} sx={{ width: "100%", m: 0 }}>
        <Grid item xs={12} sm={12} md={12} sx={{ pl: "0 !important", pt: "8px !important" }}>
          <EventPerformanceReport />
        </Grid>
        <Grid item xs={12} sm={12} md={6} sx={{ pl: { xs: "0 !important", md: "8px !important" }, pt: "8px !important" }}>
          <CancelationReasonReport />
        </Grid>
        <Grid item xs={12} sm={12} md={6} sx={{ pt: "8px !important" }}>
          <VenueReport />
        </Grid>
      </Grid>

      {/* <AccessGuard modules={[ALLOWED_MODULES.LEADS_SUMMARY]}><Counts/></AccessGuard>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
        <EventPerformanceReport />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <CancelationReasonReport />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
         <VenueReport />
        </Grid>
      </Grid> */}

    </Box>
  );
}

